import type {ReactBlockAttributes} from '@github-ui/copilot-markdown/extension'

import type {CodeVulnerability, PublicCodeReference} from '../../utils/copilot-chat-types'
import {ReferenceAnnotations} from './ReferenceAnnotations'
import {VulnerabilityAnnotations} from './VulnerabilityAnnotations'

export const vulnerabilityAnnotationsAttribute = 'data-vulnerabilityannotations-props'

export const referenceAnnotationsAttribute = 'data-referenceannotations-props'

export function DataAttributesAnnotationsBlock({
  [referenceAnnotationsAttribute]: referencesJson = '[]',
  [vulnerabilityAnnotationsAttribute]: vulnerabilitiesJson = '[]',
}: ReactBlockAttributes) {
  const references = JSON.parse(referencesJson) as PublicCodeReference[]
  const vulnerabilities = JSON.parse(vulnerabilitiesJson) as CodeVulnerability[]

  return <AnnotationsBlock references={references} vulnerabilities={vulnerabilities} />
}

interface AnnotationsBlockProps {
  references?: PublicCodeReference[]
  vulnerabilities?: CodeVulnerability[]
}

export function AnnotationsBlock({references, vulnerabilities}: AnnotationsBlockProps) {
  return (
    <>
      {references && references.length > 0 && <ReferenceAnnotations references={references} />}
      {vulnerabilities && vulnerabilities.length > 0 && <VulnerabilityAnnotations vulnerabilities={vulnerabilities} />}
    </>
  )
}

try{ DataAttributesAnnotationsBlock.displayName ||= 'DataAttributesAnnotationsBlock' } catch {}
try{ AnnotationsBlock.displayName ||= 'AnnotationsBlock' } catch {}